<template>
    <b-row> 
        <b-card-group class="col-md-6 col-sm-12 " v-for="(item, index) of items" :key="index" >
            <b-card class="shadow-lg my-3">
                <b-row no-gutters>
                    <b-col cols="4">
                        <b-card-img :src="item.imagen" alt="Image" class="mb-5" style="cursor: pointer" @click.prevent="$emit('item-info', item)"></b-card-img>
                    </b-col>
                    <b-col cols="8">
                        <b-card-text v-if="item.empresa_id != 0">
                            <a class="item-name pb-5" @click.prevent="$emit('item-info', item)">{{item.nombre}}</a> <br>
                            <div class="item-detail">
                                Item: {{item.codigo}} <br>
                                <div>Cantidad Disponible: {{numberFormat(item.existencia)}} </div>
                                <div>Código de Barras: <strong> {{item.codigo_barras}} </strong> </div>
                                <div class="producto-agotado" v-if="item.existencia == '0'"><strong>Producto Agotado</strong></div>
                            </div>
                        </b-card-text>
                        <b-card-text v-else >
                            <a class="item-name pb-2" @click.prevent="$emit('item-info', item)">{{item.nombre}}</a> <br>
                            Item: {{item.codigo}} <br>
                            <div v-if="user.tipo_terceros == 1">
                                Disponibilidad Proveedor: 
                                <b v-if="user.isMaster">{{ item.quantity }}</b>
                                <b v-else :class="$getSimpleStockClass(item.quantity)">{{ $getSimpleStockMessage(item.quantity) }}</b>
                            </div>
                            <div>Código de Barras: <strong> {{item.codigo_barras}} </strong> </div>
                            <div v-if="show_supplier_price && user.isMaster" class="pb-4">Precio Proveedor con Imp: <strong>$ {{ numberFormat(item.precio_final_prov_imp) }}</strong></div>
                            <div v-if="item.prices_by_quantity_array.length > 0">
                                <b>Precio por Volumen de Compra:</b>
                                <div v-for="(price, index) in item.prices_by_quantity_array" :key="index">
                                    <ul>
                                        <li>
                                            <b>{{price.quantity}}</b> unidades: 
                                            <span class="price-item-quantities"> ${{numberFormat(price.precio_final_con_imp)}} </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="producto-agotado" v-if="item.quantity == '0'"><strong>Producto Agotado</strong></div>
                        </b-card-text>
                    </b-col>
                </b-row>
                <template #footer>
                    <Footer :item="item" />
                </template>
            </b-card>
        </b-card-group>
    </b-row>
</template>

<script>
import { mapState} from 'vuex'
import Footer from './Footer.vue'
export default {
    name: "CardItem2",
    props: {
        items: {
            type: Array
        }       
    },
    computed: {
        ...mapState('auth', ['user']),
        ...mapState('configuration', ['show_supplier_price']),
    },
    components: {
        Footer
    },
};

</script>
<style scoped>
.card-img { 
    max-width: 100%; 
    max-height: 150px;
    object-fit: scale-down;
}

.card-text {
    font-size: 14px;
}

.producto-agotado{
    font-size: 18px;
    color: red;
}

.price-size{
    font-size: 18px;
}


</style>